module.exports = __webpack_public_path__ + "static/particulas-2498f432b11c44be9115be410d2c82f4.png";